enum FeeType {
  FLAT = "flat",
  VARIABLE = "variable"
}

export default FeeType;
